var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 499.6 499.6",
    style: {
      enableBackground: "new 0 0 499.6 499.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#513C7F"
    },
    cx: 249.6,
    cy: 249.8,
    r: 249.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#403266"
    },
    d: "M426.4,73c97.6,97.6,97.6,255.2,0,352.8s-255.2,97.6-352.8,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M340.8,368.2c-91.2,0-164.8-73.6-164.8-164.8c0-46.4,19.2-88,49.6-117.6c-80,12-141.6,80.8-141.6,164 c0,91.2,74.4,165.6,165.6,165.6c46.4,0,88-19.2,117.6-49.6C359.2,367.4,349.6,368.2,340.8,368.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8A8A8"
    },
    d: "M249.6,415.4c46.4,0,88-19.2,117.6-49.6c-8.8,1.6-17.6,2.4-26.4,2.4c-50.4,0-96-22.4-125.6-58.4"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC114"
    },
    cx: 316.8,
    cy: 114.6,
    r: 25.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCA12A"
    },
    d: "M335.2,96.2c10.4,10.4,10.4,26.4,0,36c-10.4,10.4-26.4,10.4-36,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D254C"
    },
    d: "M499.2,237.8l-82.4-82.4l-120,120l140,140C480.8,365,501.6,301,499.2,237.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#858A8C"
    },
    d: "M497.6,253.8c0,36-28,31.2-64,31.2l0,0c-36,0-64-28.8-64-64.8v-20.8c0-36,28-64.8,64-64.8l0,0 c36,0,64,28.8,64,64.8V253.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#858A8C"
    },
    d: "M401.6,239.4c0,24.8-19.2,45.6-44,45.6l0,0c-24.8,0-44-20-44-45.6V225c0-24.8,19.2-45.6,44-45.6l0,0 c24.8,0,44,20,44,45.6V239.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#858A8C"
    },
    d: "M497.6,253.8c0,16-11.2,36-27.2,36h-152c-16,0-28.8-20-28.8-36l0,0c0-16,12.8-28,28.8-28h152.8 C486.4,225.8,497.6,237.8,497.6,253.8L497.6,253.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.cadecabd077b0f54521cd30d3282cc89.svg";
export { ForwardRef as ReactComponent };